<template>
  <div class="read-text">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12">
                  <div
                    class="content-title-governet"
                  >{{legislation.legislation_category.name}}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 title-text">
                  <span>{{legislation.title}}</span>
                </div>
                <div class="col-12">
                  <div v-html="legislation.content" class="text-content"></div>
                  <div class="text-details">
                    <div
                      class="date"
                    >Data de publicação: {{formatDate(legislation.created_at)}}</div>
                  </div>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Swal from "sweetalert2";
import moment from "moment";
import SendItemEmail from "@/components/forms/SendItemEmail";
import { bus } from "@/main";

export default {
  name: "read-text",
  props: {
    id: Number
  },
  components: {
    SendItemEmail
  },
  data() {
    return {
      legislation: {},
      items: [
        {
          text: "Legislações",
          route: "public.legislations"
        },
        {
          text: "Resultado da pesquisa",
          active: true
        }
      ]
    };
  },
  mounted() {
    if (this.id) {
      this.getDataObject(this.id);
    } else {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        this.getDataObject(this.id);
      } else {
        this.$router.push({ name: "Home" });
      }
    }
  },
  methods: {
    getDataObject: function(id) {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/legislations/${id}`)
        .then(response => {
          if (response.data.error) {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Você não tem acesso a esse conteúdo",
              icon: "info",
              onClose: () => {
                this.$router.push({ name: "public.search-texts" });
              }
            });
          } else {
            this.legislation = response.data;
            bus.$emit("changeLoading", false);
          }
        });
    },
    formatDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.read-text {
  .title-text {
    font-size: 30px;
  }
  .text-content {
    padding-top: 3vh;
    padding-bottom: 3vh;
  }
  .text-details {
    font-size: 14px;
    color: #5f6064;
  }
  .send-email {
    padding-top: 1.5vh;
  }
}
</style>